import { FC } from 'react';

import { EmptyCell } from '../EmptyCellRenderer/EmptyCellRenderer';
import { CommonCellContentStyled } from '../Common.styled';
import { useGetLocationItemQuery } from 'services/teamHeroApi.service';
import { LocationCellContainerStyled } from './LocationCellRenderer.styled';

interface ILocationCellRendererProps {
  locationId?: number;
  displayCity?: boolean;
  displayCountry?: boolean;
  displayStreet?: boolean;
  displayZipCode?: boolean;
}

export const LocationCellRenderer: FC<ILocationCellRendererProps> = ({
  locationId,
  displayCity = false,
  displayCountry = false,
  displayStreet = false,
  displayZipCode = false,
}: ILocationCellRendererProps) => {
  const { data: location } = useGetLocationItemQuery(
    {
      id: locationId || 0,
    },
    { skip: !locationId }
  );

  if (!location) {
    return <EmptyCell />;
  }

  return (
    <LocationCellContainerStyled>
      <CommonCellContentStyled>
        {displayCity && location.addressCity}
        {displayCountry && location.addressCountry}
        {displayStreet && location.addressStreet}
        {displayZipCode && location.addressZip}
      </CommonCellContentStyled>
    </LocationCellContainerStyled>
  );
};
